import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { ExpensesDenoCreateSeparatePercetagePage } from '../expenses-deno-create-separate-percetage/expenses-deno-create-separate-percetage';
import { DeliberyNoteServices } from '../../../delibery_note/services';
import { Globals } from '../../../../globals';
/**
 * Generated class for the ExpensesDenoCreateSelectDenoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-expenses-deno-create-select-deno',
  templateUrl: 'expenses-deno-create-select-deno.html',
})
export class ExpensesDenoCreateSelectDenoPage {

  update_state: boolean = false;
  number: any;
  date: any;
  products: any;
  business_name: any;
  provider_uid: any;
  payment_method: any;
  category: any;
  payment: any;
  denos: any;
  temp: any;
  selected_collapse: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public toastCtrl: ToastController,
    public deliberyNoteServices: DeliberyNoteServices,
    public globals: Globals) {

    this.update_state = this.navParams.get('update_state');
    this.number = this.navParams.get('number');
    this.date = this.navParams.get('date');
    this.business_name = this.navParams.get('business_name');
    this.provider_uid = this.navParams.get('provider_uid');
    this.payment_method = this.navParams.get('payment_method');
    this.category = this.navParams.get('category');
    this.payment = this.navParams.get('payment');

  }

  async ionViewWillEnter() {
    // Establecer el uid_provider_selected antes de cargar los albaranes
    // Esto asegura que el filtro funcione correctamente incluso si el servicio se reinicia
    // o si el usuario navega de vuelta a esta página
    if (this.provider_uid) {
      this.deliberyNoteServices.uid_provider_selected = this.provider_uid;
    } else {
      console.error('provider_uid no está definido en navParams');
      this.denos = [];
      this.temp = [];
      return;
    }
    
    // Verificar que uid_provider_selected esté establecido antes de cargar
    if (!this.deliberyNoteServices.uid_provider_selected) {
      console.error('uid_provider_selected no está establecido antes de llamar a getListDeno');
      this.denos = [];
      this.temp = [];
      return;
    }
    
    this.denos = await this.deliberyNoteServices.getListDeno(this.globals.restaurant_uid);
    this.temp = this.denos;
  }

  ionViewWillLeave() {
    if (this.next == false) {
      this.deliberyNoteServices.delibery_notes_array_tmp = Array();
    }
  }

  public next: boolean = false;
  openDenoFinal() {
    this.globals.GAtrackView('ProviderOrders', 'ProviderOrders - Select delibery notes - Create', this.globals.restaurant.email, 'Create/Update', 'Create provider order select delibery notes ', 'ProviderOrders', this.number);
    this.next = true;
    this.navCtrl.push(ExpensesDenoCreateSeparatePercetagePage, {
      number: this.number,
      date: this.date,
      business_name: this.business_name,
      provider_uid: this.provider_uid,
      payment_method: this.payment_method,
      category: this.category,
      payment: this.payment,
    });
  }

  updateFilter(event) {
    const val = event.target.value;

    if (val && val.trim() != '') {
      // filter our data
      const temp = this.denos.filter(function (d) {
        var day = new Date(d.date.toDate()).getDate().toString();
        var month = (new Date(d.date.toDate()).getMonth() + 1).toString();
        var year = new Date(d.date.toDate()).getFullYear().toString();
        if (parseInt(day) < 10) {
          day = '0' + day;
        }
        if (parseInt(month) < 10) {
          month = '0' + month;
        }
        if (d.total.toFixed(2).toString().indexOf(val.toLowerCase()) > -1) {
          return d;
        } else if (d.number.indexOf(val.toLowerCase()) > -1) {
          return d;
        } else if ((day + '/' + month + '/' + year).indexOf(val.toLowerCase()) > -1) {
          return d;
        }
      });
      // update the rows
      this.denos = temp;
    } else {
      this.denos = this.temp;
    }
  }
  collapse() {
    this.selected_collapse = !this.selected_collapse;
  }
}


// WEBPACK FOOTER //
// ./src/pages/income-expenses/expenses-deno-create/expenses-deno-create-select-deno/expenses-deno-create-select-deno.ts